import {
  countryNames,
  currentIntlLocale,
  prioritizeCountries,
} from '@vestigas/utils';

import { Select } from './Select';
import { type SelectProps } from './types';

type CountrySelectProps<T> = Omit<SelectProps<T>, 'options'>;

/**
 * A select component for selecting countries.
 * Supports German and English locales by default.
 */
export const CountrySelect = <T,>({
  className,
  errors,
  isClearable = true,
  isDisabled = false,
  isMultiSelect = false,
  onChange,
  placeholder = 'Land auswählen',
  style,
  testId,
  value,
  ...rest
}: CountrySelectProps<T>) => {
  const language = new Intl.Locale(currentIntlLocale()).language;
  const options = prioritizeCountries(
    Object.entries(countryNames.getNames(language)),
    ([code]) => code,
  ).map(([key, value]) => ({
    label: value,
    value: key,
  }));

  return (
    <Select
      className={className}
      errors={errors}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isMultiSelect={isMultiSelect}
      options={options}
      placeholder={placeholder}
      style={style}
      testId={testId}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
};
